import { useMutation, useQuery } from '@apollo/client/react';
import {
  RECORD_INVENTORY_ADJUSTMENT,
  GET_INVENTORY_ADJUSTMENT_REASONS,
} from 'api/graphql/inventory';
import { GET_VENDOR_CATALOG } from 'api/graphql/catalog';
import { useVendor } from 'features/vendor';
import env from 'config/env';

/** Loads the inventory-adjustment reason enum (damaged / expired / recount …). */
export function useAdjustmentReasons() {
  const { data, loading } = useQuery(GET_INVENTORY_ADJUSTMENT_REASONS, {
    variables: { languageCode: env.defaultLanguage },
    errorPolicy: 'all',
  });
  return { reasons: data?.getInventoryAdjustmentReasonEnum ?? [], loading };
}

/**
 * Records a stock correction (`quantityDelta` is signed: positive adds stock,
 * negative removes it) and refreshes the catalog.
 */
export function useInventoryAdjustment() {
  const { vendorId } = useVendor();

  const [mutate, { loading }] = useMutation(RECORD_INVENTORY_ADJUSTMENT, {
    refetchQueries: vendorId ? [{ query: GET_VENDOR_CATALOG, variables: { vendorId } }] : [],
    awaitRefetchQueries: true,
  });

  const recordAdjustment = async ({ vendorCatalogId, quantityDelta, reason, notes, clientRequestId }) => {
    const input = {
      vendorId,
      vendorCatalogId,
      quantityDelta,
      reason,
      ...(notes ? { notes } : {}),
      ...(clientRequestId ? { clientRequestId } : {}),
    };
    const { data } = await mutate({ variables: { input } });
    return data?.recordInventoryAdjustment ?? null;
  };

  return { recordAdjustment, loading };
}
